module.exports = __webpack_public_path__ + "static/media/Att-3.08e6d520.png";